export default {
  'promoHeader': 'Vous vous souvenez?',
  'add':'Ajouter',
  'pickSize':'Choisir la taille',
  'cartHeader':'Votre panier:',
  'addUniid':'Ajouter nom et numéro',
  'remove':'Supprimer',
  'freeDelivery':'La livraison est offerte!',
  'toCheckout':'Passer au règlement',
  'totalPrice':'Total:',
  'totalDiscount':'Remise totale:',
  'deliveryPrice':'Frais de livraison',
  'size':'Taille:',
  'getTomoz':'',
  'totalVAT':'Prix total TVA:',
  'consent': 'Yes - I allow Unisport to send me email and sms\'s on similar football products. I can unsubscribe at any time in the email or by un-ticking this box, should the communication not be as expected.'
}